var React = require('react');

function SliderArrowPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9668 0.000406653C10.7073 0.00821023 10.4615 0.11746 10.2801 0.302795L0.292603 10.2914C-0.0975344 10.6815 -0.0975344 11.3136 0.292603 11.7038L10.2801 21.6924C10.5298 21.9538 10.9024 22.0592 11.2535 21.9675C11.6027 21.8758 11.8758 21.6026 11.9675 21.2534C12.0591 20.9023 11.9538 20.5297 11.6924 20.2799L2.41105 10.9976L11.6924 1.71524C11.987 1.42846 12.0767 0.98951 11.9167 0.609085C11.7548 0.230612 11.3784 -0.011299 10.9668 0.000406653Z","fill":"#001D3B"}));
}

SliderArrowPrev.defaultProps = {"width":"12","height":"22","viewBox":"0 0 12 22","fill":"none"};

module.exports = SliderArrowPrev;

SliderArrowPrev.default = SliderArrowPrev;
